import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

const theme = process.env.VUE_APP_THEME;

const themeColors = {
  neuralike: {
    primary: '#ff7700',
    secondary: '#fdb800',
  },
  openvoxel: {
    primary: '#c23807',
    secondary: '#f34609',
  },
}[theme];

export default new Vuetify({
  theme: {
    themes: {
      light: themeColors,
    },
    options: {
      // Set CSS variables for theme colors (e.g. "--v-primary-base")
      customProperties: true,
    },
  },
});
